"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Image = _interopRequireDefault(require("../Image"));
var _Price = _interopRequireDefault(require("../Price"));
var _Date = _interopRequireDefault(require("../Date"));
var _constant = require("../Date/constant");
var _GiftDetails = _interopRequireDefault(require("./GiftDetails.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/prop-types */

var GiftDetailsWrapper = _styledComponents.default.div.withConfig({
  displayName: "GiftDetails__GiftDetailsWrapper",
  componentId: "sc-12rfivk-0"
})(["padding:16px;background-color:", ";display:flex;flex-direction:column;gap:16px;"], function (_ref) {
  var bgColor = _ref.bgColor;
  return bgColor;
});
GiftDetailsWrapper.displayName = 'GiftDetailsWrapper';
var Banner = _styledComponents.default.div.withConfig({
  displayName: "GiftDetails__Banner",
  componentId: "sc-12rfivk-1"
})([""]);
Banner.displayName = 'Banner';
var BookingDetailsSection = _styledComponents.default.div.withConfig({
  displayName: "GiftDetails__BookingDetailsSection",
  componentId: "sc-12rfivk-2"
})(["background-color:#ffffff;border-radius:4px;padding:16px;display:flex;flex-direction:row;flex-wrap:wrap;gap:16px;"]);
BookingDetailsSection.displayName = 'BookingDetailsSection';
var ProductDetails = _styledComponents.default.div.withConfig({
  displayName: "GiftDetails__ProductDetails",
  componentId: "sc-12rfivk-3"
})([""]);
ProductDetails.displayName = 'ProductDetails';
var ProductDetailItemRow = _styledComponents.default.div.withConfig({
  displayName: "GiftDetails__ProductDetailItemRow",
  componentId: "sc-12rfivk-4"
})(["display:flex;align-items:center;flex-wrap:wrap;gap:4px;"]);
ProductDetailItemRow.displayName = 'ProductDetailItemRow';
var AmountSection = _styledComponents.default.div.withConfig({
  displayName: "GiftDetails__AmountSection",
  componentId: "sc-12rfivk-5"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:baseline;"]);
AmountSection.displayName = 'AmountSection';
var GiftDetails = function GiftDetails(_ref2) {
  var accessible = _ref2.accessible,
    theme = _ref2.theme,
    currencyFormat = _ref2.currencyFormat,
    currency = _ref2.currency,
    locale = _ref2.locale,
    totalAmount = _ref2.totalAmount,
    bgColor = _ref2.bgColor,
    productImgHeight = _ref2.productImgHeight,
    productImgWidth = _ref2.productImgWidth,
    bookingDetails = _ref2.bookingDetails,
    translation = _ref2.translation;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var renderBookingDetailsSection = function renderBookingDetailsSection() {
    var title = bookingDetails.title,
      imageUrl = bookingDetails.imageUrl,
      validTill = bookingDetails.validTill;
    return /*#__PURE__*/_react.default.createElement(BookingDetailsSection, null, /*#__PURE__*/_react.default.createElement(Banner, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      theme: theme,
      accessible: accessible,
      src: imageUrl,
      radius: "4px",
      height: productImgHeight,
      width: productImgWidth
    })), /*#__PURE__*/_react.default.createElement(ProductDetails, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "textLarge",
      display: "inline"
    }, title), validTill && /*#__PURE__*/_react.default.createElement(ProductDetailItemRow, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      bold: true,
      type: "small",
      color: "greyDark"
    }, translation.validUntil), /*#__PURE__*/_react.default.createElement(_Date.default, {
      theme: theme,
      date: new Date(validTill),
      format: _constant.DATE_FORMATS['Short Full Simple Date'],
      size: "XSmall",
      color: "greyDark"
    }))));
  };
  var renderAmountSection = function renderAmountSection() {
    return /*#__PURE__*/_react.default.createElement(AmountSection, null, /*#__PURE__*/_react.default.createElement(_Text.default, null, translation.totalPayment), /*#__PURE__*/_react.default.createElement(_Price.default, {
      accessible: accessible,
      allowLocaleFormat: true,
      amount: totalAmount,
      currency: currency,
      currencyDisplay: "code",
      customFontSize: "sub",
      decimalType: currencyFormat,
      locale: locale,
      theme: theme
    }));
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(GiftDetailsWrapper, {
      bgColor: bgColor
    }, renderBookingDetailsSection(), renderAmountSection());
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
GiftDetails.propTypes = _GiftDetails.default.PropTypes;
GiftDetails.defaultProps = _GiftDetails.default.DefaultProps;
var _default = GiftDetails;
exports.default = _default;